import { routes } from "consts";
import React from "react";
import { ChangelogArticle, ChangelogBody, LinkTo } from "../components";

export const Article20241103 = (): JSX.Element | null => {
  return (
    <ChangelogArticle date="11 Listopada, 2024" header="Nowa wersja 1.4.0" labels={["bugfix", "feature"]}>
      <ChangelogBody title="1. Integracja z systemami WooCommerce">
        <b className="text-orange-500">{"(beta)"}</b> Możliwość dodawania{" "}
        <LinkTo to={routes.INTEGRATIONS}>integracji WooCommerce</LinkTo>
      </ChangelogBody>
      <ChangelogBody title="2. Tryb ciemny i poprawki wizualne">
        Poprawiono wygląd aplikacji w trybie ciemnym.
        <ul>
          <li>
            - <LinkTo to={routes.COURSES_EDIT_NESTED.PREVIEW("1")}>edytor WysWig</LinkTo>
          </li>
          <li>
            - <LinkTo to={routes.COURSES_EDIT_NESTED.SESSION("1")}>mapowanie zjazdów</LinkTo>
          </li>
          <li> - ujednolicenie cieni i tabel</li>
        </ul>
      </ChangelogBody>
      <ChangelogBody title="3. Poprawki do generowania dokumentów">
        Na ekranie <LinkTo to={routes.COURSES_MANAGE_NESTED.DOCUMENTS("1")}>generowania dokumentów</LinkTo> dla kursu,
        dodano <b>auto-odświeżanie</b>.
      </ChangelogBody>
      <ChangelogBody title="4. Możliwość dodania placeholdera HTML do dokumentu">
        Na ekranie <LinkTo to={routes.DOCUMENTS}>edycji dokumentu</LinkTo> dodano możliwość dodania placeholdera HTML.
      </ChangelogBody>

      <ChangelogBody title="5. Edycja i usuwanie kosztów kursu">
        Na ekranie <LinkTo to={routes.COURSES_MANAGE_NESTED.FINANCES("1")}>bilansu ogólnego</LinkTo> kursu możliwość
        edycji i usuwania kosztów.
      </ChangelogBody>

      <ChangelogBody title="6. Poprawki drobnych błędów">
        <ul>
          <li>
            - Na ekranie <LinkTo to={routes.COURSES_EDIT_NESTED.SCHEDULE("1")}>edycji harmonogramu</LinkTo> dodano
            podgląd cen
          </li>
          <li>
            - Na ekranie <LinkTo to={routes.COURSES_EDIT_NESTED.SCHEDULE("1")}>edycji harmonogramu</LinkTo> poprawiono
            źle wyświetlające się dni
          </li>
          <li>
            - Na ekranie <LinkTo to={routes.COURSES_EDIT_NESTED.SCHEDULE("1")}>edycji harmonogramu</LinkTo> dodano
            możliwość edycji trenerów i poprawiono błąd przy edycji.
          </li>
          <li>
            - Na ekranie <LinkTo to={routes.TOPICS_GROUPS_ADD}>tworzenia grupy tematów</LinkTo> dodano czyszczenie
            formularza po dodaniu nowego tematu.
          </li>
        </ul>
      </ChangelogBody>
    </ChangelogArticle>
  );
};
